import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Firebase's web config identifies the project; it is not a secret and is
// safe to ship in client code. Actual access control lives in firestore.rules.
const firebaseConfig = {
  apiKey: 'AIzaSyCmUnbLymXcsSYiN3lI2RkKkCG1oXseFi4',
  authDomain: 'theapplebythetree.firebaseapp.com',
  projectId: 'theapplebythetree',
  storageBucket: 'theapplebythetree.firebasestorage.app',
  messagingSenderId: '766528155836',
  appId: '1:766528155836:web:897c346289ec4f367ae0b9',
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();
